import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { MIATableModel, ApiPagination } from '@mobileia/core';
import { BaseTableService } from 'src/app/services/base-table.service';
import { AlertService } from 'src/app/services/alert.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-base-table',
  templateUrl: './base-table.component.html',
  styleUrls: ['./base-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class BaseTableComponent<T> implements OnInit {

  isSending = false;
  isLoading = true;
  tableModel = new MIATableModel();
  displayedColumns = [];
  configColumns = [];
  dataItems = new ApiPagination<T>();
  service: BaseTableService<any>;
  filterSearch = '';
  filterSearchCodigo = '';
  filterSearchNombre = '';
  filterSearchApellido = '';
  filterSearchId = '';
  filterSearchExternalCode = '';
  
  constructor(
    protected alertService: AlertService
  ) { }

  ngOnInit(): void {
  }

  loadItems() {
    this.isLoading = true;
    this.service.fetchList(this.tableModel).toPromise().then(data => {
        this.isLoading = false;
        if (!data.success) {
            this.alertService.showError('Error!', data.error.message);
            return;
        }
        this.dataItems = data.response;
    }).catch(error => {
        this.isLoading = false;
        this.alertService.showError('Error!', error);
    });
  }

  onRemove(item: any) {
    this.isLoading = true;
    this.service.remove(item.id).toPromise().then(data => {
        this.isLoading = false;
        if (data.success) {
            this.loadItems();
        }
    });
  }

  openItem(item: T) { }

  onPageChange(event: PageEvent) {
    this.tableModel.itemPerPage = event.pageSize;
    this.tableModel.pageCurrent = event.pageIndex + 1;
    this.loadItems();
  }
}
